import React, { useEffect, useState } from 'react';
const CelebrationEffect: React.FC = () => {
  const [particles, setParticles] = useState<Array<{
    id: number;
    color: string;
    x: number;
    y: number;
    size: number;
  }>>([]);
  useEffect(() => {
    const colors = ['#FF5252', '#FFD740', '#64FFDA', '#448AFF', '#B388FF', '#FF80AB'];
    const newParticles = [];
    for (let i = 0; i < 100; i++) {
      newParticles.push({
        id: i,
        color: colors[Math.floor(Math.random() * colors.length)],
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 8 + 2
      });
    }
    setParticles(newParticles);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-50 flex items-center justify-center" data-id="element-2">
      <div className="absolute inset-0" data-id="element-3">
        {particles.map(particle => <div key={particle.id} className="absolute rounded-full animate-float" style={{
        backgroundColor: particle.color,
        width: `${particle.size}px`,
        height: `${particle.size}px`,
        left: `${particle.x}%`,
        top: `${particle.y}%`,
        animationDuration: `${Math.random() * 2 + 1}s`,
        animationDelay: `${Math.random() * 0.5}s`
      }} data-id="element-4" />)}
      </div>
      <div className="bg-white bg-opacity-90 p-8 rounded-xl shadow-lg text-center animate-bounce-slow" data-id="element-5">
        <h2 className="text-3xl font-bold text-green-600 mb-2" data-id="element-6">Great job!</h2>
        <p className="text-xl" data-id="element-7">Exercise completed!</p>
      </div>
    </div>;
};
export default CelebrationEffect;